import assertNever from "./helpers/assertNever";

const getCurrentVariables = (env: Environment = "local"): EnvironmentVariables => {
  switch (env) {
    case "production": {
      return {
        environment: env,
        __IMGIX_ENV__: "production",
        __HOOPLA_GTM__: "GTM-TPVQ84K",
        __HOOPLA_GA__: "UA-24366495-6",
        __HOOPLA_GA4__: "G-FP4YJ544MT",
        __SENTRY_DSN__: "https://628c25c7ab6a4d979b4179937daa5509@o17242.ingest.sentry.io/1860787",
        __MAPTILER_API_KEY__: "KSlXAW5Iyw0wx12LODol",
        __NETS_CHECKOUT_KEY__: "live-checkout-key-56ebd9ac975f46f199c46ba3cfb31933",
        __NETS_CHECKOUT_URL__: "https://checkout.dibspayment.eu/v1/checkout.js?v=1",
      };
    }
    case "staging":
      return {
        environment: env,
        __IMGIX_ENV__: "staging",
        __HOOPLA_GTM__: "GTM-544LHK5",
        __HOOPLA_GA__: "UA-24366495-5",
        __HOOPLA_GA4__: "G-G47TMPLM0G",
        __SENTRY_DSN__: "https://b690ad9d182446fbaed45e8ae7c327a3@sentry.io/1860791",
        __MAPTILER_API_KEY__: "dU0sTnsDGExfkJYm5S1o",
        __NETS_CHECKOUT_KEY__: "test-checkout-key-df6af1b81ab74b17ad57b6360d1a4e31",
        __NETS_CHECKOUT_URL__: "https://test.checkout.dibspayment.eu/v1/checkout.js?v=1",
      };
    case "local": {
      return {
        environment: env,
        __IMGIX_ENV__: "staging",
        __HOOPLA_GTM__: "GTM-544LHK5",
        __HOOPLA_GA__: "UA-24366495-5",
        __HOOPLA_GA4__: "G-G47TMPLM0G",
        __SENTRY_DSN__: "",
        __MAPTILER_API_KEY__: "fVR8bJ6nWsrGtkhc0KmB",
        __NETS_CHECKOUT_KEY__: "test-checkout-key-df6af1b81ab74b17ad57b6360d1a4e31",
        __NETS_CHECKOUT_URL__: "https://test.checkout.dibspayment.eu/v1/checkout.js?v=1",
      };
    }
    default:
      assertNever(env);
  }
};

export const setGlobalEnvironmentVariables = (env: Environment) => {
  window.ENVIRONMENT = getCurrentVariables(env);
};

export const getCheckoutDomain = () => {
  switch (window.ENVIRONMENT.environment) {
    case "production":
      return "checkout.hoopla.no";
    case "staging":
      return "checkout.hoopladev.no";
    case "local":
      return "checkout.hoopla.local:5173";
  }
};
